export default "__VITE_ASSET__HZXo1nvg__"